import { useLanguage } from '../i18n/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, toggleLanguage, isRTL } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-full bg-sky-800/50 hover:bg-sky-700/50 border border-sky-600/30 transition-colors text-sm ${className}`}
      data-testid="language-switcher"
      aria-label={`Switch to ${language === 'en' ? 'Arabic' : 'English'}`}
    >
      <Globe size={16} className="text-sky-300" />
      <span className="text-white font-medium">
        {language === 'en' ? 'عربي' : 'EN'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;
